module.exports = __webpack_public_path__ + "img/logos (7).544734da.png";